
import React, {useState} from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Sidebar from "./sidebar";
import "./layout.css"

const Layout = ({ currentPage, modified, children }) => {
  // this is only relevant when the sidebar is hidden
  const [showSidebar, setShowSidebar] = useState(false);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} 
        onMenu={()=>setShowSidebar(! showSidebar)}/>
        <Sidebar  
          currentPage={currentPage}
          unhide={showSidebar} />
        <div className="main-page">
        <main >{children}</main>
        <footer>
        © Christopher Andrews/ Michael Linderman {new Date().getFullYear()}, Last updated {modified}
        </footer>
        </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  currentPage: PropTypes.shape({
    path: PropTypes.string,
    title: PropTypes.string
  }),
  modified: PropTypes.string,
}

export default Layout
